/**
 * @generated SignedSource<<f1f997687a2c0e105c66cb62811ee815>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemovePanelistInput = {
  block?: boolean | null;
  clientMutationId?: string | null;
  panelistId: string;
};
export type PanelistModal_RemovePanelist_Mutation$variables = {
  input: RemovePanelistInput;
};
export type PanelistModal_RemovePanelist_Mutation$data = {
  readonly removePanelist: {
    readonly panelist: {
      readonly id: string;
    } | null;
  } | null;
};
export type PanelistModal_RemovePanelist_Mutation = {
  response: PanelistModal_RemovePanelist_Mutation$data;
  variables: PanelistModal_RemovePanelist_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemovePanelistPayload",
    "kind": "LinkedField",
    "name": "removePanelist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelistNode",
        "kind": "LinkedField",
        "name": "panelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PanelistModal_RemovePanelist_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PanelistModal_RemovePanelist_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc3abc89dbc94366b5471b7150a76886",
    "id": null,
    "metadata": {},
    "name": "PanelistModal_RemovePanelist_Mutation",
    "operationKind": "mutation",
    "text": "mutation PanelistModal_RemovePanelist_Mutation(\n  $input: RemovePanelistInput!\n) {\n  removePanelist(input: $input) {\n    panelist {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5f1d77d915cc046c41244ce64e21ba1";

export default node;
